<template>
  <div class="main">
    <div class="scroll-box" ref="scrollBox">
      <main class="content">
        <van-grid :column-num="2" :gutter="5" :border="false">
          <van-grid-item class="grid-item" v-for="item in imgList" :key="item.posterId">
            <div class="img-box">
              <van-image
                width="100%"
                height="auto"
                fit="contain"
                :src="item.imgUrl"
              />
              <div class="del-img-btn" @click="deleteImg(item.posterId, item.imgUrl)">
                <van-icon class="del-icon" name="cross" size="12" />
              </div>
            </div>
          </van-grid-item>
          
          <van-grid-item class="grid-item">
            <van-uploader
              :before-read="beforeImgUpload" 
              :after-read="uploadImg">
                <div class="img-box add-box" :class="{uploading: isUploading}">
                  <van-loading v-if="isUploading" size="30" vertical>上传中...</van-loading>
                  <van-icon v-else name="photograph" size="30" />
                </div>
            </van-uploader>
          </van-grid-item>
        </van-grid>
      </main>
    </div>
    <footer>
      <div class="footer-btn plain" @click="goBack">返回</div>
      <!-- <div class="footer-btn " @click="saveDraft">保存</div> -->
    </footer>
  </div>
</template>

<script>
import loadingMixin from '@/mixins/loading-mixin'
export default {
  name: 'ActivityPoster',
  mixins: [loadingMixin],
  data() {
    return {
      imgList: [],
      relationGroupId: '',
      loading: null,
      isUploading: false
    }
  },
  methods: {
    init() {
      if (!this.$route.query.activityId) {
        return;
      }

      this.showLoading();
      this.$api.activityMgmt.getPostersById(this.$route.query.activityId)
        .then(({data}) => {
          this.relationGroupId = data.activityRelationGroupId;
          this.imgList = data.activityPoster
            && data.activityPoster.map(item => ({
              posterId: item.posterId,
              imgUrl: item.imgUrl
            }))
            || [];
        })
        .finally(_ => {
          this.hideLoading();
        });
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }

      // const isLt5M = (file.size / 1024 / 1024) > 5;
      // if (isLt5M) {
      //   this.$toast('图片大小不能超过 5MB');
      //   return false;
      // }

      return true;
    },
    uploadImg(file) {
      this.isUploading = true;
      this.$api.common.uploadImg(file.file)
        .then(({data}) => {
          if (data && data[0]) {
            this.addImg(data[0].fileUrl);
          }
        }).finally(_ => {
          this.isUploading = false;
        });
    },
    addImg(imgUrl) {
      const params = {
        relationGroupId: this.relationGroupId,
        imgUrl,
        sortNo: this.imgList.length + 1
      };
      this.showLoading();
      this.$api.activityMgmt.addPoster(params)
        .then(() => {
          this.init();
        })
        .finally(_ => {
          this.hideLoading();
        });
    },
    deleteSourceImg(fileUrl) {
      this.$api.common.deleteFile(fileUrl)
        .then(() => {
        });
    },
    deleteImg(posterId, fileUrl) {
      this.showLoading();
      this.$api.activityMgmt.deletePoster(posterId)
        .then(() => {
          // this.deleteSourceImg(fileUrl);
          this.init();
        })
        .finally(_ => {
          this.hideLoading();
        });
      
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  created() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.main
  .scroll-box
    height: calc(100vh - 64px)
    // height: 100vh
    overflow-y auto
    &::-webkit-scrollbar
      display: none
    .content
      padding 10px 5px

  .img-box
    display: flex
    justify-content: center
    align-items: center
    box-sizing: border-box
    position relative
    width 155px
    height: 220px
    border-radius: 6px
    background-color: #f0f0f0
    overflow hidden
    .del-img-btn
      position absolute
      right 0
      top 0
      width 20px 
      height 20px
      background-color rgba(0, 0, 0, 0.7)
      border-radius 0 0 0 18px
      .del-icon
        top -2px
        right -5px
        color #fff

  .add-box
    border 1px dotted #bbb
  .empty-block
    height: 42px

  .grid-item
    >>> .van-grid-item__content
      padding 8px
      background: transparent
    
  footer
    box-sizing: border-box
    position fixed
    left 0
    bottom 0
    z-index 999
    padding 0 10px
    height 64px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    background-color #fff

    .footer-btn
      padding 10px 50px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    .footer-btn-s
      padding 10px 15px
    .plain
      color $mainTextColor
      background-color: #fff

</style>
